import React, { Component } from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';

import AccessControl from 'components/AccessControl';
import ActivityPerms from 'components/AccessControl/permissions.json';
import IndividualValidationResult, { buildDescription } from 'components/IndividualValidationResult';
import FormWorkflowStages from 'common/Workflows/FormWorkflowStages';

import {
  saveDraftValidationOverrides,
  acceptValidationOverrides,
  getStorageSetting
} from 'actions';

class IndividualValidationOverridesSection extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    permissions: PropTypes.arrayOf(PropTypes.string),
    workflowStage: PropTypes.number,
    workflowUsername: PropTypes.string,
    valid: PropTypes.bool.isRequired,
    rejections: PropTypes.arrayOf(PropTypes.shape({
      code: PropTypes.string,
      codeDescription: PropTypes.string
    })).isRequired,
    warnings: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    overrides: PropTypes.shape({
      current: PropTypes.shape({}),
      draft: PropTypes.shape({})
    }),
    formType: PropTypes.string.isRequired,
    formId: PropTypes.number.isRequired,
    customerId: PropTypes.string,
    customerName: PropTypes.string,
    isOnlineForm: PropTypes.bool.isRequired,
    isSavingValidationOverrides: PropTypes.bool,
    isWithTreaty: PropTypes.bool,
    isLocked: PropTypes.bool
  };

  static defaultProps = {
    permissions: null,
    workflowStage: 0,
    workflowUsername: null,
    customerId: '',
    customerName: '',
    overrides: null,
    isSavingValidationOverrides: false,
    isWithTreaty: false,
    isLocked: false
  };

  constructor(props) {
    super(props);

    const existingOverrides = props.overrides.draft ? props.overrides.draft : props.overrides.current;
    const formOverride = existingOverrides ? existingOverrides.formOverride : {
      override: false,
      valid: props.valid,
      comments: ''
    };

    let overrideEntries = [];
    if (props.rejections != null) {
      overrideEntries = props.rejections;

      overrideEntries.map((obj) => {
        if (obj != null) {
          const existingOverride = existingOverrides != null
            && existingOverrides.rejections != null && existingOverrides.rejections.filter(item => item.code === obj.code);

          obj.selected = !!(existingOverride != null && existingOverride[0] != null);
          obj.reason = existingOverride != null && existingOverride[0] != null ? existingOverride[0].reason : '';
          obj.comments = existingOverride != null && existingOverride[0] != null ? existingOverride[0].comments : '';
          return obj;
        }
        return null;
      });
    }

    this.state = {
      formOverride,
      overrideEntries
    };
  }

  onFormOverrideSelected(e) {
    const { formOverride } = this.state;

    formOverride.override = e.target.checked;
    formOverride.valid = !e.target.checked;
    formOverride.comments = '';
    this.setState({
      formOverride
    });
  }

  onFormOverrideCommentChange(e) {
    const { formOverride } = this.state;

    formOverride.comments = e.target.value;
    this.setState({
      formOverride
    });
    e.preventDefault();
  }

  onOverrideSelected(e, code) {
    const { overrideEntries } = this.state;

    if (overrideEntries != null) {
      overrideEntries.filter(item => item.code === code).map((obj) => {
        if (obj != null) {
          obj.selected = e.target.checked;
          if (!e.target.checked) {
            obj.reason = '';
            obj.comments = '';
          }
          return obj;
        }
        return null;
      });

      this.setState({
        overrideEntries
      });
    }
  }

  onOverrideReasonChange(e, code) {
    const { overrideEntries } = this.state;
    if (overrideEntries != null) {
      overrideEntries.filter(item => item.code === code).map((obj) => {
        if (obj != null) {
          obj.reason = e.target.value;
          return obj;
        }
        return null;
      });

      this.setState({
        overrideEntries
      });
    }
    e.preventDefault();
  }

  onOverrideCommentChange(e, code) {
    const { overrideEntries } = this.state;

    if (overrideEntries != null) {
      overrideEntries.filter(item => item.code === code).map((obj) => {
        if (obj != null) {
          obj.comments = e.target.value;
          return obj;
        }
        return null;
      });

      this.setState({
        overrideEntries
      });
    }
    e.preventDefault();
  }

  onSaveOverrides() {
    const { dispatch, formId } = this.props;
    const { overrideEntries, formOverride } = this.state;

    const selectedEntries = overrideEntries != null ? overrideEntries.filter(item => item.selected) : null;

    dispatch(saveDraftValidationOverrides(formId, {
      formOverride: formOverride ? {
        isDraft: true,
        override: formOverride.override,
        valid: formOverride.valid,
        reason: '4',
        comments: formOverride.comments
      } : null,
      rejections: selectedEntries
    }));
  }

  onAcceptOverrides() {
    const { dispatch, formId } = this.props;
    const { overrideEntries, formOverride } = this.state;

    const selectedEntries = overrideEntries != null ? overrideEntries.filter(item => item.selected) : null;

    dispatch(acceptValidationOverrides(formId, {
      formOverride: formOverride ? {
        isDraft: false,
        override: formOverride.override,
        valid: formOverride.valid,
        reason: '4',
        comments: formOverride.comments
      } : null,
      rejections: selectedEntries
    }));
  }

  getOverriddenRejections() {
    const { overrideEntries, formOverride } = this.state;

    return overrideEntries != null && {
      current: {
        formOverride: formOverride ? {
          isDraft: true,
          override: formOverride.override,
          valid: formOverride.valid,
          reason: '4',
          comments: formOverride.comments
        } : null,
        rejections: overrideEntries.filter(item => item.selected)
      }
    };
  }

  canOverride() {
    const { permissions, workflowStage, workflowUsername } = this.props;

    const isUserFormOwner = workflowUsername != null && workflowUsername === getStorageSetting('username');
    const hasReviewerPermission = AccessControl.hasPermission(permissions, [ActivityPerms.fwfInitialReviewer, ActivityPerms.fwfSecondaryReviewer, ActivityPerms.fwfExpertReviewer, ActivityPerms.fwfSupplReviewer]);

    if (workflowStage === FormWorkflowStages.Complete || workflowStage === FormWorkflowStages.BatchStaging) {
      // WF is Complete or Batch Staging
      return false;
    }

    return isUserFormOwner && hasReviewerPermission;
  }

  render() {
    const {
      isSavingValidationOverrides,
      formId,
      customerId,
      customerName,
      formType,
      isOnlineForm,
      valid,
      rejections,
      warnings,
      isWithTreaty,
      isLocked
    } = this.props;

    const { overrideEntries, formOverride } = this.state;

    return (
      <div className="validation-overrides">
        <h1>Validation Overrides</h1>
        <div className="validation-overrides-content">
          <div className="overrides-entry">
            <div className="result-block">
              { !valid && <p>If you received or sourced information additional to this tax document that causes any of the rejections listed below to be incorrect, please take the following steps:</p> }
              { valid && <p>If you received or sourced information additional to this tax document that causes the validation result to be incorrect, please take the following steps:</p> }
              <ol>
                { !valid && <li>Please select an applicable reason,</li> }
                { valid && <li>Please check the check box next to the Invalidate form text below,</li> }
                <li>Please enter a short rationale to the text box below,</li>
                <li>Please upload any supporting document substantiating your notes,</li>
                <li>Please save your changes. </li>
              </ol>
              <p>Once you have finished with your edits please click the “Accept” button at the bottom of the page to apply your changes.</p>
              <div className="reasons-for-rejection-list">
                { (!rejections || rejections.length === 0) && formOverride && <div className="form-override">
                  <p><em>Invalidate this form.</em></p>
                  <label className="form-checkbox">
                    <input
                      id="form-override-cb"
                      type="checkbox"
                      value="Yes"
                      checked={ formOverride.override }
                      disabled={ !this.canOverride() }
                      onChange={ e => this.onFormOverrideSelected(e) }
                    />
                    <i className="form-icon" />
                  </label>
                  { formOverride && formOverride.override && <select
                    id="form=override-dd"
                    className="form-select"
                    disabled
                    value="4"
                  >
                    <option value="">Select a reason</option>
                    <option value="1">Supporting document attached.</option>
                    <option value="2">Exception approval attached.</option>
                    <option value="3">System issue.</option>
                    <option value="4">Client specific treatment, specified below.</option>
                    <option value="5">Other reason, specified below.</option>
                  </select> }
                  { formOverride && formOverride.override && <textarea
                    id="form-override-ta"
                    className="form-input"
                    rows="3"
                    value={ formOverride.comments }
                    disabled={ !this.canOverride() }
                    onChange={ e => this.onFormOverrideCommentChange(e) }
                  /> }
                </div> }
                <ul>
                  { overrideEntries != null && overrideEntries.length !== 0 && overrideEntries.map(rejection => rejection != null && rejection.code.substring(3) !== '500000' && (
                    <li key={ rejection.key }>
                      <p><em>{ buildDescription(rejection) }</em>
                      &nbsp;(<strong>{ rejection.code }</strong>)</p>
                      <label className="form-checkbox">
                        <input
                          id={ `override-cb-${ rejection.key }` }
                          type="checkbox"
                          value="Yes"
                          checked={ rejection.selected }
                          disabled={ !this.canOverride() }
                          onChange={ e => this.onOverrideSelected(e, rejection.code) }
                        />
                        <i className="form-icon" />
                      </label>
                      { rejection.selected && <select
                        id={ `override-dd-${ rejection.key }` }
                        className="form-select"
                        value={ rejection.reason }
                        disabled={ !this.canOverride() }
                        onChange={ e => this.onOverrideReasonChange(e, rejection.code) }
                      >
                        <option value="">Select a reason</option>
                        <option value="1">Supporting document attached.</option>
                        <option value="2">Exception approval attached.</option>
                        <option value="3">System issue.</option>
                        <option value="4">Client specific treatment, specified below.</option>
                        <option value="5">Other reason, specified below.</option>
                      </select> }
                      { rejection.selected && <textarea
                        id={ `override-ta-${ rejection.key }` }
                        className="form-input"
                        rows="3"
                        maxLength="2000"
                        value={ rejection.comments }
                        disabled={ !this.canOverride() }
                        onChange={ e => this.onOverrideCommentChange(e, rejection.code) }
                      /> }
                    </li>
                  )) }
                </ul>
              </div>
            </div>
            <div className="form-group save-draft text-right">
              <div className="col-12">
                <button
                  id="save-overrides-btn"
                  type="button"
                  className={ `btn btn-primary ${ !this.canOverride() ? 'none' : '' }` }
                  disabled={ isSavingValidationOverrides }
                  onClick={ () => this.onSaveOverrides() }
                >
                  Save
                </button>
              </div>
            </div>
          </div>
          <div className="validation-result-content">
            <div className="preview-result validation-result-message">
              <h1>Validation Result Preview</h1>
              <IndividualValidationResult
                formId={ formId }
                customerId={ customerId }
                customerName={ customerName }
                formType={ formType }
                isOnlineForm={ isOnlineForm }
                valid={ valid }
                rejections={ rejections }
                warnings={ warnings }
                overrides={ this.getOverriddenRejections() }
                isWithTreaty={ isWithTreaty }
                isLocked={ isLocked }
                calculateValidity
              />
              <div className="form-group">
                <div className="col-12 text-right">
                  <button
                    id="accept-overrides-btn"
                    type="button"
                    className={ `btn btn-primary ${ !this.canOverride() ? 'none' : '' }` }
                    disabled={ isSavingValidationOverrides }
                    onClick={ () => this.onAcceptOverrides() }
                  >
                    Accept
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {
    forms: {
      isSavingValidationOverrides,
    }
  } = state;

  return {
    isSavingValidationOverrides,
  };
}

const mapDispatchToProps = dispatch => ({ dispatch });

const IndividualValidationOverrides = connect(
  mapStateToProps,
  mapDispatchToProps
)(IndividualValidationOverridesSection);

export default IndividualValidationOverrides;
